import './audiotag'
import './webaudio'
import './webmidi'



/** WEBPACK FOOTER **
 ** ./~/.5.0.0@standard-loader!./src/plugins/index.js
 **/